import React from "react";
import HeadlineKpiCard from "../../components/ui-components/HeadlineKpiCard";
import { humanEUR } from "../cost-control/forecast/format";
import { fmtSignedMoney, fmtSignedPct } from "../investigations/format";

// One metric tile — flex-1 (not w-*) so cards share the row evenly; the theme
// overrides the width scale, but the flex scale is intact.
function KpiCard(props) {
  return <HeadlineKpiCard {...props} className="flex-1" />;
}

// AnalyzerKpiStrip — scope-aware headline KPIs above the chart, fed by the same
// decomposition/forecast the drivers query already returns for the current scope
// (date range + filters). Presentational: all values are passed in.
export default function AnalyzerKpiStrip({ totalSpend = 0, priorSpend = 0, delta = 0, periodProjection = null, aiSavings = null }) {
  const pct = priorSpend > 0 ? (100 * delta) / priorSpend : null;
  const up = delta >= 0;

  return (
    <div className="flex gap-3">
      <KpiCard
        label="Total spend · this range"
        value={humanEUR(totalSpend)}
        sub={pct != null ? `${fmtSignedMoney(delta)} (${fmtSignedPct(pct)}) vs prior period` : "no prior period"}
        subTone={pct != null ? (up ? "text-danger" : "text-success") : "text-text-3"}
      />
      <KpiCard
        label={periodProjection && !periodProjection.hasForecast ? "Actual · period total" : "Projected · period end"}
        value={periodProjection ? humanEUR(periodProjection.total) : "—"}
        sub={
          !periodProjection
            ? "projection unavailable for this period"
            : periodProjection.hasForecast && periodProjection.totalP90 > periodProjection.total
              ? `90% range up to ${humanEUR(periodProjection.totalP90)}`
              : null
        }
      />
      {aiSavings && aiSavings.shadow > 0 && (() => {
        const over = aiSavings.actual > aiSavings.shadow;
        const pct = over
          ? Math.round((100 * aiSavings.shadow) / aiSavings.actual)
          : Math.round(100 * aiSavings.discountPct);
        return (
          <KpiCard
            label={over ? "AI subscription utilization" : "AI subscription savings"}
            value={over ? `${pct}% used` : `${pct}% saved`}
            sub={`${humanEUR(aiSavings.actual)} actual · ${humanEUR(aiSavings.shadow)} API-equivalent`}
            subTone={over ? "text-warning" : "text-success"}
          />
        );
      })()}
    </div>
  );
}
